import React from 'react';
import { formatLocationFilterOptionLabel } from '../../utils/locationDisplay';
import './LocationFilterMultiSelect.css';

function LocationFilterMultiSelect({
  locations = [],
  value = [],
  onChange,
  className = '',
  disabled = false,
  minHeight = '90px',
  emptyMessage = 'No locations available.',
}) {
  if (!locations.length) {
    return <div className="location-filter-multiselect-empty">{emptyMessage}</div>;
  }

  const normalizedValue = (value || []).map((id) => String(id));

  return (
    <select
      className={['filter-select', 'location-filter-multiselect', className].filter(Boolean).join(' ')}
      multiple
      value={normalizedValue}
      disabled={disabled}
      style={{ minHeight }}
      onChange={(e) => {
        const selected = Array.from(e.target.selectedOptions, (option) => option.value);
        onChange(selected);
      }}
    >
      {locations.map((loc) => (
        <option key={loc.id} value={String(loc.id)}>
          {formatLocationFilterOptionLabel(loc)}
        </option>
      ))}
    </select>
  );
}

export default LocationFilterMultiSelect;
